import React, { FunctionComponent, useCallback } from "react";
import styles from "./MediaCloudItem.module.scss";
import MediaCloudItemContent from "./MediaCloudItem.interface";

import { OPEN_MEDIA_CLOUD_DOWNLOAD_OVERLAY, OPEN_MEDIA_CLOUD_EMAIL_OVERLAY } from "layout/redux/overlay.actions";
import { useDispatch } from "react-redux";
import combineClasses from "helpers/combine-classes";
import Dictionary from "components/Dictionary/Dictionary";
import IconViewer from "components/IconViewer/IconViewer";
import ImageViewer from "components/ImageViewer/ImageViewer";
import a4Skilt from "assets/a4-skilt-sort-baggrund.jpg";
import isBrowserContext from "helpers/isBrowserContext";

const MediaCloudItem: FunctionComponent<MediaCloudItemContent> = (props) => {
    const dispatch = useDispatch();
    
    const onDownloadButtonClick = useCallback((props: any) => {
        dispatch({
            type: OPEN_MEDIA_CLOUD_DOWNLOAD_OVERLAY,
            content: props
        });
    }, []);

    const onEmailButtonClick = useCallback((props: any) => {
        dispatch({
            type: OPEN_MEDIA_CLOUD_EMAIL_OVERLAY,
            content: props
        });
    }, []);

    const getImageUrl = (src: string): string => {
        const isPdf = src.endsWith(".pdf");

        if (isPdf && isBrowserContext()) {
            return `${window.location.origin}${a4Skilt}`;
        } else {
            return src;
        }
    };
    
    return (
        <div className={combineClasses([styles.wrapper, props.className])}>
            {/* Image */}
            {props.url ? (
                <ImageViewer className={styles.image} src={getImageUrl(props.url)} aspectRatioX={1} aspectRatioY={1} type="containX" focalPoint={{ left: 0.5, top: 0.5 }} />
            ) : null}

            {/* Buttons */}
            <div className={styles.buttons}>
                <button className={styles.button} onClick={() => onDownloadButtonClick(props)}>
                    <IconViewer className={styles.button_icon} name="download" />
                    <Dictionary name="MEDIA_CLOUD.ITEM.DOWNLOAD" />
                </button>
                <button className={styles.button} onClick={() => onEmailButtonClick(props)}>
                    <IconViewer className={styles.button_icon} name="mail" />
                    <Dictionary name="MEDIA_CLOUD.ITEM.EMAIL" />
                </button>
            </div>

            {props.children}
        </div>
    );
};

export default MediaCloudItem;